import React, { useState } from "react";

// React Router Dom
import { Link, useNavigate } from "react-router-dom";

// Supabase
import { supabase } from "../../supabase";

// Hooks
import useSnackbarNotification from "../../hooks/useSnackbarNotification";

const ForgotPassword = () => {
    const { showError, showSuccess } = useSnackbarNotification();
    const navigate = useNavigate();
    
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const { error } = await supabase.auth.resetPasswordForEmail(email, {
                redirectTo: "https://doctorsjobs.io/reset-password",
            });

            if (error) throw error;
            showSuccess("Password reset link has been sent to your email! Please check your spam/junk folder if you don't see it.");
            setLoading(false);
        } catch (error) {
            showError("An error occurred while sending the reset link");
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex">
            <div className="hidden md:flex md:w-1/2 bg-gray-50  flex-col space-y-6 overflow-auto">
                <img
                    src="/login.jpg"
                    alt="Login"
                    className="w-full h-full object-cover"
                />
            </div>

            <div className="w-full md:w-1/2 bg-gray-50 flex flex-col justify-center px-8 md:px-20">
                <div className="max-w-md w-full mx-auto">
                    <div
                        className="logo cursor-pointer justify-center mb-8"
                        onClick={() => navigate("/")}
                    >
                        Doctors' Jobs <span className="logo-badge">Beta</span>
                    </div>

                    <h2 className="text-2xl font-bold text-black text-center mb-8">
                        Forgot Password
                    </h2>
                    <p className="text-sm text-black text-center mb-8">
                        Enter your email address below and we'll send you a link
                        to reset your password.
                    </p>

                    {error && (
                        <div className="mb-6 rounded-md bg-red-50 p-4 text-red-700 text-sm">
                            {error}
                        </div>
                    )}

                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label
                                htmlFor="email"
                                className="block text-base md:text-lg font-medium text-gray-700 mb-1"
                            >
                                Email Address *
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>

                        <div>
                            <button
                                type="submit"
                                disabled={loading}
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50"
                            >
                                {loading ? "Sending..." : "Send Reset Link"}
                            </button>
                        </div>
                    </form>

                    <p className="mt-6 text-center text-sm text-gray-600">
                        Remember your password?{" "}
                        <Link
                            to="/login"
                            className="font-medium text-black hover:text-gray-700"
                        >
                            Login
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
